/** Above `.team-assistant-workspace--fullscreen` (1200) and app header (1000). */
export const TEAM_ASSISTANT_OVERLAY_Z_INDEX = 1400;
